import { BreakdownListHelper } from '../helpers/BreakdownListHelper';
import type { BreakdownListId, IComponentFacts } from '../types/report';
import { EmptyFacts } from './EmptyFacts';

interface IBreakdownListProps {
  list: BreakdownListId;
  facts: IComponentFacts;
}

export const BreakdownList = ({ list, facts }: IBreakdownListProps) => {
  const model = BreakdownListHelper.model(list, facts);
  if (model.rows.length === 0) return <EmptyFacts />;

  return (
    <div className="flex h-full flex-col gap-md">
      <p className="flex items-baseline justify-between gap-md txt-small-regular text-text-secondary">
        <span className="truncate">{model.heading}</span>
        <span className="tabular-nums text-text-primary">{model.total}</span>
      </p>
      <ol className="flex flex-col gap-md">
        {model.rows.map((row) => (
          <li key={row.key} className="flex flex-col gap-xs">
            <div className="flex items-baseline justify-between gap-md txt-small-regular">
              <span className="truncate text-text-primary">{row.name}</span>
              <span className="shrink-0 tabular-nums text-text-secondary">
                {BreakdownListHelper.rowText(row, facts.currency)}
              </span>
            </div>
            <div
              role="presentation"
              className="h-[3px] w-full overflow-hidden rounded-full bg-border-secondary"
            >
              <div
                className="h-full rounded-full bg-fg-secondary"
                style={{ width: `${Math.round(row.scale * 100)}%` }}
              />
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};
